import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@/core/api/type'
import { MessagingQueryKey } from '../../keys'
import MessagingService from '../services'
import {
	GetChannelTransactionsRequest,
	GetChannelTransactionsResponse,
} from '../../types'

function useQueryGetChannelTransactions(
	payload: GetChannelTransactionsRequest,
	props?: UseBaseQueryOptions<GetChannelTransactionsResponse>,
) {
	return useQuery({
		queryKey: [MessagingQueryKey.GetChannelTransactions, payload],
		queryFn: () => MessagingService.getChannelTransactions(payload),
		...props,
	})
}

export default useQueryGetChannelTransactions
